import { Card } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';

interface FlexEDataPreviewProps {
  data: Array<{ timestamp: string; kw: number }>;
}

export default function FlexEDataPreview({ data }: FlexEDataPreviewProps) {
  if (!data || data.length === 0) return null;

  return (
    <Card className="p-4">
      <h3 className="text-sm font-medium mb-2">Preview (eerste 10 rijen)</h3>
      <div className="border rounded-lg overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Tijdstip</TableHead>
              <TableHead className="text-right">Vermogen (kW)</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.slice(0, 10).map((row, index) => (
              <TableRow key={index}>
                <TableCell className="font-mono text-sm">{row.timestamp}</TableCell>
                <TableCell className="text-right font-mono">{row.kw.toFixed(2)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </Card>
  );
}
